var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBaseRoute)?_c('v-container',{staticClass:"page-content px-sm-5",staticStyle:{"margin":"0px","width":"100%"}},[(!_vm.check)?_c('WelcomePage',{on:{"goPortal":_vm.goPortal,"goGuest":_vm.goGuest}}):_vm._e(),(_vm.check)?_c('SurveysList'):_vm._e()],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }